/**
 * Language Selector.
 * @format
 */

import React, { useEffect, useState } from 'react';
import LanguageRegion from './language-region';
import { useStateValue } from '@context/state-context';
import Translate from '@components/translation/translate-text-wrapper';
import ModalWrapper from '@components/modals/modal-wrapper';

/**
 * Language Selector.
 */
const LanguageSelector = (): JSX.Element | null => {
  const [{ updateToggle }, dispatch] = useStateValue();
  const [showModal, setShowModal] = useState(false);

  /**
   * Toggle Language Selector.
   */
  useEffect(() => {
    dispatch({
      type: 'toggleLocale',
      updateLocale: {
        localeOpen: showModal,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  /**
   * Sets state when Modal is open.
   */
  useEffect(() => {
    if (updateToggle.localeOpen) {
      setShowModal(true);
    }
  }, [updateToggle.localeOpen]);

  /**
   * Render.
   */
  return (
    <ModalWrapper
      showModal={updateToggle.localeOpen}
      setShowModal={setShowModal}
      className={'region-modal modal-width-80'}>
      <div className="header-container">
        <h2 className="left-align-text">
          <Translate>Select Your Region / Language</Translate>
        </h2>
      </div>

      <div className="grid-2-columns">
        <div className="grid-item">
          <LanguageRegion region="americas" />
          <LanguageRegion region="apac" />
        </div>
        <div className="grid-item">
          <LanguageRegion region="emia" />
        </div>
      </div>
    </ModalWrapper>
  );
};
export default LanguageSelector;
